<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <div class="page_title flex between">
      <span>医生评价列表</span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <div class="box">
            <div class="searchbox">
              <div class="item">
                <span>医生姓名</span>
                <el-input
                  placeholder="请输入"
                  v-model="doctor_name"
                  style="width: 160px; margin-left: 12px"
                  @change="search"
                  clearable
                ></el-input>
              </div>
              <div class="item">
                <span>医生手机</span>
                <el-input
                  placeholder="请输入"
                  v-model="doctor_phone"
                  style="width: 160px; margin-left: 12px"
                  @change="search"
                  clearable
                ></el-input>
              </div>
              <div class="item">
                <span>患者姓名</span>
                <el-input
                  placeholder="请输入"
                  v-model="user_name"
                  style="width: 160px; margin-left: 12px"
                  @change="search"
                  clearable
                ></el-input>
              </div>
              <div class="item">
                <span>用户昵称</span>
                <el-input
                  placeholder="请输入"
                  v-model="nick_name"
                  style="width: 160px; margin-left: 12px"
                  @change="search"
                  clearable
                ></el-input>
              </div>
              <div class="item">
                <span>用户手机</span>
                <el-input
                  placeholder="请输入"
                  v-model="user_phone"
                  style="width: 160px; margin-left: 12px"
                  @change="search"
                  clearable
                ></el-input>
              </div>
              <div class="item">
                <span>评分范围</span>
                <el-input-number
                  v-model="evaluate_start"
                  :min="0"
                  :max="5"
                  :precision="1"
                  style="width: 90px; margin-left: 12px"
                  :controls="false"
                ></el-input-number>
                <span style="margin: 0 5px">-</span>
                <el-input-number
                  v-model="evaluate_end"
                  :min="0"
                  :max="5"
                  :precision="1"
                  style="width: 90px"
                  :controls="false"
                ></el-input-number>
              </div>
              <div class="item">
                <span>评价类型</span>
                <el-select
                  style="width: 160px; margin-left: 12px"
                  v-model="evaluate_type"
                  placeholder="请选择"
                >
                  <el-option label="全部" :value="0"> </el-option>
                  <el-option label="问诊评价" :value="1"> </el-option>
                  <el-option label="开方评价" :value="2"> </el-option>
                </el-select>
              </div>
              <div class="item">
                <span>
                  <span>评价标签</span>
                  <el-select
                    style="width: 160px; margin-left: 12px"
                    v-model="evaluate_label"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in labelList"
                      :key="item.label_name"
                      :label="item.label_name"
                      :value="item.label_name"
                    >
                    </el-option>
                  </el-select>
                </span>
              </div>
              <div class="item">
                <span>评价日期</span>
                <el-date-picker
                  v-model="date"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  style="width: 264px; margin-left: 12px"
                  @change="search"
                  clearable
                ></el-date-picker>
              </div>
              <div class="item">
                <span>审核状态</span>
                <el-select
                  style="width: 160px; margin-left: 12px"
                  v-model="status"
                  placeholder="请选择"
                >
                  <el-option label="全部" value="-1"> </el-option>
                  <el-option label="待审核" value="0"> </el-option>
                  <el-option label="已通过" value="1"> </el-option>
                  <el-option label="不通过" value="2"> </el-option>
                </el-select>
                <el-button
                  type="info"
                  style="
                    background-color: #eceff2;
                    color: #747981;
                    margin-left: 10px;
                  "
                  @click="search"
                  >查询</el-button
                >
              </div>
            </div>
            <div class="searchbox">
              <el-button
                type="primary"
                @click="batchCheckUserEvaluate"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1141') : false
                "
                >批量审核</el-button
              >
              <el-button
                type="primary"
                @click="addData"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('1142') : false
                "
                >导入数据</el-button
              >
            </div>
            <div style="border: solid 1px #c9cbd6">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }"
                @sort-change="changeOrder"
                @selection-change="handleSelectionChange"
              >
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column label="用户信息">
                  <template slot-scope="scope">
                    <div>{{ scope.row.user_name }}</div>
                    <div>{{ scope.row.patient_phone }}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="患者姓名"
                  prop="user_name"
                ></el-table-column>

                <el-table-column label="医生信息">
                  <template slot-scope="scope">
                    <div
                      @click="showDocMsg(scope.row.doctor_id)"
                      style="cursor: pointer"
                    >
                      {{ scope.row.doctor_name }}
                    </div>
                    <div>{{ scope.row.doctor_phone }}</div>
                  </template>
                </el-table-column>

                <el-table-column label="评价类型">
                  <template slot-scope="scope">
                    <div v-if="scope.row.evaluate_type == 1">问诊评价</div>
                    <div v-if="scope.row.evaluate_type == 2">开方评价</div>
                  </template>
                </el-table-column>

                <el-table-column label="病情描述/主诉">
                  <template slot-scope="scope">
                    <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.diagnosis_desc"
                      placement="top-start"
                    >
                      <div class="multiline-ellipsis">
                        {{ scope.row.diagnosis_desc }}
                      </div>
                    </el-tooltip>
                  </template>
                </el-table-column>

                <el-table-column
                  label="评价分数"
                  prop="evaluate"
                  sortable="custom"
                ></el-table-column>
                <el-table-column
                  label="评价标签"
                  prop="evaluate_label"
                ></el-table-column>
                <el-table-column
                  label="评价内容"
                  prop="evaluate_content"
                ></el-table-column>
                <el-table-column
                  label="评价时间"
                  prop="create_time"
                  sortable="custom"
                ></el-table-column>
                <el-table-column label="审核状态">
                  <template slot-scope="scope">
                    <div v-if="scope.row.status == 0">待审核</div>
                    <div v-if="scope.row.status == 1">已通过</div>
                    <div v-if="scope.row.status == 2" class="red">不通过</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="审核人"
                  prop="admin_user_name"
                ></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="checkUserEvaluate(scope.row.ev_id)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('1140')
                          : false
                      "
                      >审核</el-button
                    >
                    <!-- 问诊 -->
                    <el-button
                      v-if="
                        scope.row.evaluate_type == 1 &&
                        scope.row.evaluate_business_id
                      "
                      type="text"
                      @click="
                        toDetail(
                          scope.row.evaluate_type,
                          scope.row.evaluate_business_id
                        )
                      "
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('50')
                          : false
                      "
                      >详情</el-button
                    >
                    <!-- 订单 -->
                    <el-button
                      v-if="
                        scope.row.evaluate_type == 2 &&
                        scope.row.evaluate_business_id
                      "
                      type="text"
                      @click="
                        toDetail(
                          scope.row.evaluate_type,
                          scope.row.evaluate_business_id
                        )
                      "
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('115')
                          : false
                      "
                      >详情</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                style="margin: 20px 0"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ImportData :isFlag="importData" @refreshData="getList"></ImportData>
  </div>
</template>
<script>
import dayjs from "dayjs";
import DocMsg from "../../../components/common/DocMsg.vue";
import ImportData from "./ImportData.vue";
export default {
  data() {
    return {
      totalNum: 0,
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      doctor_name: "",
      doctor_phone: "",
      user_name: "",
      nick_name: "",
      user_phone: "",
      evaluate_start: undefined,
      evaluate_end: undefined,
      evaluate_type: 0,
      evaluate_label: "全部",
      date: [],
      prop: "",
      order_by: "",
      labelList: [],
      doc_msg: false,
      doctorId: "",
      status: "-1",
      multipleSelection: [],
      importData: false,
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  components: {
    DocMsg,
    ImportData,
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        user_name: this.user_name,
        nick_name: this.nick_name,
        user_phone: this.user_phone,
        evaluate_start: this.evaluate_start,
        evaluate_end: this.evaluate_end,
        evaluate_type: this.evaluate_type,
        evaluate_label:
          this.evaluate_label == "全部" ? "" : this.evaluate_label,
        prop: this.prop,
        order_by: this.order_by,
        status: this.status == -1 ? "" : Number(this.status),
      };
      if (this.date && this.date.length > 0) {
        data.evaluate_start_date = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.evaluate_end_date = dayjs(this.date[1]).format("YYYY-MM-DD");
      }

      this.axios
        .post("platform/doctor/getUserEvaluateLog", data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list.map((item) => {
              item.create_time = dayjs
                .unix(item.create_time)
                .format("YYYY-MM-DD HH:mm");
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    // 获取医生评价标签列表
    getDoctorEvaluateLabelList() {
      this.axios
        .post("platform/doctor/getDoctorEvaluateLabelList")
        .then((res) => {
          if (res.code == 0) {
            let list = res.data.list;
            list.unshift({ label_name: "全部" });
            this.labelList = res.data.list;
          }
        });
    },
    changeOrder(value) {
      this.prop = value.prop;
      //升序
      if (value.order == "ascending") {
        this.order_by = "asc";
      }
      //降序
      if (value.order == "descending") {
        this.order_by = "desc";
      }
      if (!value.order) {
        this.prop = "";
        this.order_by = "";
      }
      this.getList();
    },
    //创建
    toSavePre() {
      this.$router.push("savepre");
    },
    //修改备注
    changeremark(pre_agr_id, remark) {
      let data = {
        pre_agr_id,
        remark,
      };
      this.axios
        .post("platform/photograph/saveDocAgreePrescriptionRemark", data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("保存成功");
            this.getList();
          }
        });
    },
    //详情
    toDetail(evaluate_type, evaluate_business_id) {
      //问诊详情
      if (evaluate_type == 1) {
        this.$router.push({
          name: "wenzhendetail",
          query: {
            consult_id: evaluate_business_id,
          },
        });
      } else {
        //订单详情
        this.$router.push({
          name: "orderdetail",
          query: {
            order_id: evaluate_business_id,
          },
        });
      }
    },
    back() {
      history.back();
    },
    //审核
    checkUserEvaluate(id) {
      this.$confirm("是否审核通过?", "审核", {
        confirmButtonText: "通过",
        cancelButtonText: "不通过",
        distinguishCancelAndClose: true,
      })
        .then((res) => {
          let data = {
            ev_id: id,
            status: 1,
          };
          this.axios
            .post("platform/doctor/checkUserEvaluate", data)
            .then((res2) => {
              this.getList();
            });
        })
        .catch((action) => {
          if (action === "cancel") {
            let data = {
              ev_id: id,
              status: 2,
            };
            this.axios
              .post("platform/doctor/checkUserEvaluate", data)
              .then((res2) => {
                this.getList();
              });
          }
        });
    },
    //批量审核
    batchCheckUserEvaluate() {
      if (this.multipleSelection.length == 0) {
        this.$message.error("请选择评价");
        return;
      }
      let ev_ids = this.multipleSelection.map((ele) => {
        return ele.ev_id;
      });
      this.$confirm("是否审核通过?", "审核", {
        confirmButtonText: "通过",
        cancelButtonText: "不通过",
        distinguishCancelAndClose: true,
      })
        .then((res) => {
          let data = {
            ev_ids,
            status: 1,
          };
          console.log(data);
          this.axios
            .post("platform/doctor/batchCheckUserEvaluate", data)
            .then((res2) => {
              this.getList();
            });
        })
        .catch((action) => {
          if (action === "cancel") {
            let data = {
              ev_ids,
              status: 2,
            };
            this.axios
              .post("platform/doctor/batchCheckUserEvaluate", data)
              .then((res2) => {
                this.getList();
              });
          }
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //导入数据
    addData() {
      this.importData = !this.importData;
    },
  },
  activated() {
    let query = this.$route.query;
    if (query) {
      this.doctor_name = query.doctor_name;
      this.doctor_phone = query.doctor_phone;
      this.getList();
    } else {
      this.getList();
    }
    this.getDoctorEvaluateLabelList();
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 1px 20px;
  .searchbox {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    .item {
      margin-right: 30px;
      margin-top: 24px;
      display: flex;
      align-items: center;
    }
  }
}
.videobox {
  width: 100px;
  height: 70px;
  position: relative;
  cursor: pointer;
  .videoimg {
    width: 100%;
    height: 100%;
  }
  .onvideo {
    width: 30px;
    position: absolute;
    top: 20px;
    left: 35px;
  }
}
.imgbox {
  display: flex;
  padding: 30px;
  box-sizing: border-box;
  justify-content: space-between;
}
.dialog {
  padding: 20px 20px 0;
}
</style>
